import React, { useState } from 'react';
import hd01 from '../../assets/images/charity/hd01.jpg';
import hd02 from '../../assets/images/charity/hd02.jpg';
import hd03 from '../../assets/images/charity/hd03.jpg';
import hd04 from '../../assets/images/charity/hd04.jpg';
import hd05 from '../../assets/images/charity/hd05.jpg';

const VideoSection = () => {
  const [selectedImage, setSelectedImage] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [mouseStart, setMouseStart] = useState(null);
  const [mouseEnd, setMouseEnd] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const charityImages = [
    { src: hd01, alt: 'Hoạt động thiện nguyện 1' },
    { src: hd02, alt: 'Hoạt động thiện nguyện 2' },
    { src: hd03, alt: 'Hoạt động thiện nguyện 3' },
    { src: hd04, alt: 'Hoạt động thiện nguyện 4' },
    { src: hd05, alt: 'Hoạt động thiện nguyện 5' },
  ];

  const nextImage = () => {
    setSelectedImage((prev) => (prev + 1) % charityImages.length);
  };

  const prevImage = () => {
    setSelectedImage((prev) => (prev - 1 + charityImages.length) % charityImages.length);
  };

  // Touch/Swipe functionality
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      nextImage();
    } else if (isRightSwipe) {
      prevImage();
    }
  };

  // Mouse drag functionality
  const onMouseDown = (e) => {
    setIsDragging(true);
    setMouseStart(e.clientX);
    setMouseEnd(e.clientX);
  };

  const onMouseMove = (e) => {
    if (!isDragging) return;
    setMouseEnd(e.clientX);
  };

  const onMouseUp = () => {
    if (!isDragging || !mouseStart || !mouseEnd) {
      setIsDragging(false);
      return;
    }

    const distance = mouseStart - mouseEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      nextImage();
    } else if (isRightSwipe) {
      prevImage();
    }

    setIsDragging(false);
  };

  const onMouseLeave = () => {
    setIsDragging(false);
  };

  return (
    <section
      id="video-activity"
      className="w-full px-2 mx-auto my-2 lg:px-4 xl:px-6"
      style={{ backgroundColor: 'rgb(248 250 252)' }}
    >
      <div className="w-full">
        <div className="flex items-center justify-center gap-4 sm:gap-6 lg:gap-10 mb-3 sm:mb-4 md:mb-8">
          <div className="flex-grow h-0 border-b-2 border-orange-200"></div>
          <h2
            className="text-lg sm:text-xl md:text-2xl lg:text-[30px] font-bold text-center uppercase leading-tight flex-shrink-0"
            style={{
              color: '#fe6601',
            }}
          >
            HÌNH ẢNH
          </h2>
          <div className="flex-grow h-0 border-b-2 border-orange-200"></div>
        </div>

        {/* Full Width Swipe Gallery */}
        <div className="relative overflow-hidden">
          <div
            className="flex transition-transform duration-500 ease-in-out cursor-grab active:cursor-grabbing"
            style={{ transform: `translateX(-${selectedImage * 100}%)` }}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={onMouseUp}
            onMouseLeave={onMouseLeave}
          >
            {charityImages.map((image, index) => (
              <div key={index} className="w-full flex-shrink-0">
                <div className="aspect-[16/9] w-full">
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover select-none"
                    draggable={false}
                    loading={index === 0 ? 'eager' : 'lazy'}
                    decoding="async"
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevImage}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-all duration-200"
            aria-label="Previous image"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>

          <button
            onClick={nextImage}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-all duration-200"
            aria-label="Next image"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        {/* Dots Indicator */}
        <div className="flex justify-center gap-2 mt-4">
          {charityImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setSelectedImage(index)}
              className={`w-2 h-2 rounded-full transition-all duration-200 ${
                index === selectedImage
                  ? 'bg-[#fe6601] scale-125'
                  : 'bg-[#fe6601]/50 hover:bg-[#fe6601]/75'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
